import { OrderRequest } from '@shared/model/order';

export const productCountFromRequests = (requests: OrderRequest[]) => {
    return requests.reduce((acc, request) => {
        return request.quantity + acc;
    }, 0);
};
